<!-- Created by Richard on 15/03/2021-->
<!-- Placeholder that can be added to any page that is still under construction -->

<template>
  <h5> This page is still under construction</h5>
</template>

<script>
export default {
  name: "UnderConstruction",
}
</script>

<style scoped>

</style>